"use client";

import { Footer } from "@/app/(site)/(main)/components/Footer";
import { cn } from "@repo/ui/lib";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

interface RootWrapperProps {
  children: ReactNode;
  leftAside?: ReactNode;
  rightAside?: ReactNode;
}

export function RootWrapper({ children, leftAside, rightAside }: RootWrapperProps) {
  const pathname = usePathname();
  const isZincBg = pathname.startsWith("/me/result/");
  const isWhiteLabel = pathname.startsWith("/wl/");
  const showFooter = !isWhiteLabel;
  return (
    <div className="flex min-h-svh justify-center ">
      {leftAside && (
        <aside className="hidden min-w-0 shrink overflow-hidden lg:block">
          <div className="sticky top-15 pr-4">{leftAside}</div>
        </aside>
      )}
      <main
        className={cn(
          "flex flex-col w-full max-w-[600px] min-h-svh overflow-x-clip shrink-0 shadow-[0px_4px_20px_0px_rgba(9,9,11,0.08)]",
          isZincBg ? "bg-zinc-50" : "bg-background",
        )}
      >
        <div className="flex-1">{children}</div>
        {showFooter && <Footer />}
      </main>
      {rightAside && (
        <aside className="hidden min-w-0 shrink overflow-hidden lg:block">
          <div className="sticky top-15 pl-4">{rightAside}</div>
        </aside>
      )}
    </div>
  );
}
